import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PostMemberBody } from '@snootsvet/shared'

import { useViewerRegion } from '@/frontend/features/region/region-context'
import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Mutation hook for creating a new member in the active region. Invalidates the members list on success. */
export function useCreateMember() {
  const api = useOsApi()
  const queryClient = useQueryClient()
  const { region } = useViewerRegion()

  return useMutation({
    mutationFn: async (body: PostMemberBody) => {
      const response = await api.post('/members', { body: { ...body, region } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.member
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['members'] })
    },
  })
}
